var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('transition',{attrs:{"name":"modal","appear":""}},[_c('div',{staticClass:"modal-window"},[_c('div',{staticClass:"modal-content"},[_vm._t("default")],2)])])}
var staticRenderFns = []

export { render, staticRenderFns }